import React, { Component } from 'react';
import _ from 'lodash';
import { Form, Popup, Button, Table } from 'semantic-ui-react';
import { Form as FinalForm } from 'react-final-form';
import GraphQLError from '../Message/GraphQLError';
import DateInput from '../FinalForm/DateInput';

class ChangeDateField extends Component {
	state = {
		isOpen: false,
	}

	triggerPopup = () => {
		this.setState({ isOpen: !this.state.isOpen });
	}

	renderText = (property, value) => {
		return (
			<span className="changeInformation__value" onClick={this.triggerPopup}>{value || 'N/A'}</span>
		);
	}

	onSubmit = (values) => {
		const value = _.get(values, this.props.property, '');
		const additionalProperties = _.get(this.props, 'additionalProperties', {});

		const newValues = _.set({
			property: this.props.property,
			id: this.props.id,
		}, this.props.property, value);
		this.props.mutate({
			variables: { ...newValues, ...additionalProperties },
			refetchQueries: this.props.refetch,
		});
	}

	renderForm = (property, value) => {
		const initialValues = _.set({}, property, value);
		return(
			<FinalForm
				onSubmit={this.onSubmit}
				initialValues={initialValues}
				render={({ handleSubmit, form, submitting, pristine, values }) => (
					<Form onSubmit={handleSubmit} loading={this.props.mutateLoading}>
						<Form.Group widths='equal'>
							{/* <DateInput name={property} placeholder="New Value" label="New Value" />; */}
							<DateInput
								name={property}
								placeholder="New Value"
								label="New Value"
							/>
						</Form.Group>
						<Button fluid type='submit'>Change</Button>
						<GraphQLError error={this.props.mutateError}>There was an issue</GraphQLError>
						{/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}
					</Form>
				)}
			/>
		);
	}

	renderField = (property, value, text) => {
		return  <Popup
			trigger={this.renderText(property, text)}
			content={this.renderForm(property, value)}
			on='click'
			open={this.state.isOpen}
		/>;
	}

	render() {
		const { label, property, table } = this.props;
		const redone = _.get(this.props, 'value', '') || '';
		const redone2 = _.get(this.props, 'text', '') || '';

		if(table) {
			return(
				<Table.Row>
					<Table.Cell>{label}</Table.Cell>
					<Table.Cell>{this.renderField(property, redone, redone2)}</Table.Cell>
				</Table.Row>
			);
		}
		return (
			<p><strong>{label}:</strong>{this.renderField(property, redone, redone2)}</p>
		);
	}
}

export default ChangeDateField;